var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('v-card',{attrs:{"outlined":""}},[_c('QuemAtende',{attrs:{"cliente_id":_vm.cliente_id}})],1)],1),_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('v-card',{attrs:{"outlined":""}},[_c('ClienteServicosPrestados',{attrs:{"cliente_id":_vm.cliente_id}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }